import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Table } from 'rsuite';
import Assets from '../../../constants/image';
import { Pagination } from "react-bootstrap";
import { ArrowLeftBold, ArrowRight, DoubleArrowBold, EditIcon } from "../../../components/ThemeSvgs";
import { FixedColumnContext, TableHeightContext } from "../../../App";

const TurnoverTable = (props) => {
    const { Column, HeaderCell, Cell, TableRow } = Table; // Importing components from Rsuite Table
    const [data, setData] = useState(props?.defaultData);
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();
    const [loading, setLoading] = useState(false);
    //Table height and fixed columns of table calculated on context.
    const [tableHeight, setTableHeight] = useContext(TableHeightContext);
    const [fixedState, setFixedState] = useContext(FixedColumnContext);
    
    //Function to sort the data
    const getData = () => {
        if (sortColumn && sortType) {
            return data.sort((a, b) => {
                let x = a[sortColumn];
                let y = b[sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }
        return data;
    };

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const EmployeeCell = ({ rowData, dataKey, onClick, ...props }) => {
        console.log("-=-=-=-=", rowData[dataKey])
        return (
            <Cell {...props}>

                <div className={`${"emplpoyeeNameCell"} ${"className"}`}>
                    <NavLink to="/employees">
                        {rowData[dataKey]}
                    </NavLink>
                </div>
            </Cell>
        );
    };

    return (
        <>
            <Table
                data={getData()}
                locale={{
                    emptyMessage: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: `<div class="text-center">
                                    <div class="nodatafolder mb-2">
                                        <img src="${Assets.noDataFolder}" alt="No data found" />
                                    </div>
                                    <p>No Data Found</p>
                                    </div>`
                            }}
                        />
                    )
                }}
                height={tableHeight}
                headerHeight={72}
                hover={false}
                loading={loading}
                cellBordered={false}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
                rowClassName="turnOverRow"
            >
                <Column flexGrow={1.4} align="left" fixed={fixedState ? true : false}>
                    <HeaderCell>Employees</HeaderCell>
                    <Cell dataKey="employees" />
                </Column>

                <Column flexGrow={1}>
                    <HeaderCell>Wallys</HeaderCell>
                    <EmployeeCell dataKey="c1" />
                </Column>

                <Column flexGrow={1}>
                    <HeaderCell>Burnet</HeaderCell>
                    <EmployeeCell dataKey="c2" />
                </Column>
                <Column flexGrow={1}>
                    <HeaderCell>Manor</HeaderCell>
                    <EmployeeCell dataKey="c3" />
                </Column>
                <Column flexGrow={1}>
                    <HeaderCell>Lockhart</HeaderCell>
                    <EmployeeCell dataKey="c4" />
                </Column>
                <Column flexGrow={1}>
                    <HeaderCell>Stassney</HeaderCell>
                    <EmployeeCell dataKey="c5" />
                </Column>
                <Column flexGrow={1}>
                    <HeaderCell>Georgetown</HeaderCell>
                    <EmployeeCell dataKey="c6" />
                </Column>
                <Column flexGrow={1}>
                    <HeaderCell>Cameron</HeaderCell>
                    <EmployeeCell dataKey="c7" />
                </Column>

                <Column flexGrow={1}>
                    <HeaderCell>RoundRock</HeaderCell>
                    <EmployeeCell dataKey="c8" />
                </Column>
            </Table>
            <div className="pagiantion-box d-flex justify-content-end">
                <Pagination>
                    <Pagination.First>
                        <ArrowLeftBold />
                    </Pagination.First>
                    <Pagination.Prev className="doubleArrow rotate180" >
                        <DoubleArrowBold />
                    </Pagination.Prev>
                    <Pagination.Item active>{1}</Pagination.Item>
                    <Pagination.Item>{2}</Pagination.Item>
                    <Pagination.Ellipsis />
                    <Pagination.Item>{100}</Pagination.Item>
                    <Pagination.Next >
                        <ArrowLeftBold />
                    </Pagination.Next>
                    <Pagination.Last className="doubleArrow" >
                        <DoubleArrowBold />
                    </Pagination.Last>
                </Pagination>
            </div>
        </>
    )
}

export default TurnoverTable